import React, { lazy } from 'react';

// Lazy-loaded page components (code-split per page)
const ConciliationReport = lazy(() => import('./conciliation/ConciliationReport'));
const UsersCorrespondentReport = lazy(() => import('./UsersCorrespondentReport'));
const UsersReport = lazy(() => import('./UsersReport'));

/**
 * Reports feature permission-to-component map.
 * Keys match the `name` field from backend permissions.
 */
export const reportsPages = (_displayName: string): Record<string, React.ReactNode> => ({
  comtecoReports: <ConciliationReport bankAdmin />,
  conciliationReport: <ConciliationReport />,
  sajubaReporte: <ConciliationReport enterprise="SAJUBA" />,
  coopaguasReporte: <ConciliationReport enterprise="COOPAGUAS" />,
  correspUserReport: <UsersCorrespondentReport />,
  userReport: <UsersReport />,
});
